// Rodolfo Rivas
// 2017
// *************************************************************//
//                                                             //
//    ╔═╗┌─┐┌┬┐┌─┐┌─┐┌┐┌┌─┐┌┐┌┌┬┐┌─┐  ┬ ┬┌─┐┬ ┬┌─┐┬─┐┬┌─┐      //
//    ║  │ ││││├─┘│ ││││├┤ │││ │ ├┤   │ │└─┐│ │├─┤├┬┘││ │      //
//    ╚═╝└─┘┴ ┴┴  └─┘┘└┘└─┘┘└┘ ┴ └─┘  └─┘└─┘└─┘┴ ┴┴└─┴└─┘      //
//                                                             //
// *************************************************************//


import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UtilConfig} from '../../../../autenticacion/servicios/UtilConfig';
import {BsLocaleService} from 'ngx-bootstrap/datepicker';
import {WebServices} from '../../../recursos/modelo/consumerModel/web-services.enum';
import {ConsumerService} from '../../../recursos/servicio/consumer.service';

import {MatSnackBar} from '@angular/material';
import {Ng2DeviceService} from 'ng2-device-detector';
import {AmazingTimePickerService} from 'amazing-time-picker';
import {Emisor} from '../../seguridad/emisor/recursos/modelo/emisor';
import {LayoutService} from '../../../recursos/servicio/layout.service';
import {saveAs} from 'file-saver/FileSaver';
import {leftPad} from '../../../../../pipes/utils/utils';

declare var swal: any;

declare const $: any;

@Component({
    moduleId: module.id,
    // tslint:disable-next-line:component-selector
    selector: 'app-logHistory',
    templateUrl: './view/list-logEmisorHistory.component.html',
    styleUrls: ['./css/list-logEmisorHistory.component.css'],
    providers: [ConsumerService]
})
export class LogEmisorHistoryComponent implements OnInit {
    // ITEM DEL CRUD
    origenCRUD = 'documento';

//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─
    // variables de pantalla
    filtroList = {
        ruc: '',
        serie: '',
        correlative: '',
        document: '01',
    };
    cargandoList = false;
    mensaje = '<i class=\'material-icons\'>search</i>REALICE SU BUSQUEDA UTILIZANDO LOS FILTROS';
    loading = false;
    noHayResultados = false;
    es;
    authorities = {
        ROLE_LOG_LISTAR: false,
        ROLE_LOG_CONSULTAR: false,
        ROLE_LOG_REGISTRAR: false,
        ROLE_LOG_MODIFICAR: false,
        ROLE_LOG_ELIMINAR: false,
        ROLE_LOG_ACTIVAR: false,
    };
    ItemLista: any[];
    colorTitle = '';
    locale = 'es';
    documentType: any[] = [];
    emisor: Emisor = new Emisor();
    poseeEmisorDocumentos = false;
    empresaAdministradora = false;
    init = true;
    inicial = true;

    constructor(private consumer: ConsumerService,
                private route: ActivatedRoute,
                private router: Router,
                private snackBar: MatSnackBar,
                public jwtUtil: UtilConfig,
                private layout: LayoutService,
                private _localeService: BsLocaleService,
                private deviceService: Ng2DeviceService,
                private atp: AmazingTimePickerService) {

        this._localeService.use(this.locale);
        // VERIFICA LOS PERMISOS DEL LOG LOGEADO
        this.authorities = jwtUtil.verificarAuthorities(this.authorities);
        this.documentType = [];
        // this.documentType.push({label: 'TODOS', value: '-1'});
        this.documentType.push({label: 'FACTURA', value: '01'});
        this.documentType.push({label: 'BOLETA', value: '03'});
        this.documentType.push({label: 'NOTA DE CRÉDITO', value: '07'});
        this.documentType.push({label: 'NOTA DE DÉBITO', value: '08'});
        this.documentType.push({label: 'PERCEPCIONES', value: '40'});
        this.documentType.push({label: 'RETENCIONES', value: '20'});
        this.documentType.push({label: 'GUIA DE REMISIÓN', value: '09'});
        // this.documentType.push({label: 'GUIA TRANSPORTISTA', value: '31'});
        // this.documentType.push({label: 'RESUMEN DIARIO', value: 'SUMMARY_DOCUMENT'});
        // this.documentType.push({label: 'COMUNICACIÓN DE BAJA', value: 'RA_VOIDED_DOCUMENT'});
        // this.documentType.push({label: 'RESUMEN DE REVERSIONES', value: 'RR_VOIDED_DOCUMENT'});

        this.ItemLista = [];

        this.emisor = jwtUtil.getCurrentUser().customer;
        // SI LA EMPRESA ES ESCON SE HABILITAN LOS SELECT
        if (this.emisor.id.toString() === jwtUtil.ESCON_CUSTOMER) {
            this.empresaAdministradora = true;
        }

        this.poseeEmisorDocumentos = this.jwtUtil.poseeEmisor();
    }

    ngOnInit() {
    }

    limpiarFiltros() {
        this.filtroList.document = '-1';
        this.filtroList.correlative = '';
        this.filtroList.serie = '';

    }

    asignarDocumentoFiltro(value: string) {
        this.filtroList.document = value;
    }

    setLeftPadCorrelative(length) {
        this.filtroList.correlative = leftPad(this.filtroList.correlative, length, '0');
    }

    setLeftPad(value, length) {
        return leftPad(value, length, '0');
    }

//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴
    ejecutarDescarga() {

        if(this.filtroList.serie === '' || this.filtroList.serie.length !== 4){
            swal(
                'Debes completar los datos de descarga!',
                'La serie no puede estar vacio o no tener una longitud de 4 caracteres',
                'warning'
            );
            return;
        }
        if(this.filtroList.correlative === '' || this.filtroList.correlative === '00000000'){
            swal(
                'Debes completar los datos de descarga!',
                'El correlativo no puede estar vacio ni ser 00000000',
                'warning'
            );
            return;
        }
        // LLAMADO AL SERVICIO
        this.cargandoList = true;
        const filenameAux=  '-' +
            this.setLeftPad(this.filtroList.document, 2) + '-' +
            this.filtroList.serie.toUpperCase() + '-' +
            this.filtroList.correlative + '.zip';
        const params = {
            fileName: (this.filtroList.ruc === '') ? this.emisor.ruc + filenameAux : this.filtroList.ruc  + filenameAux,
            rucEmisor: (this.filtroList.ruc === '') ? this.emisor.ruc : this.filtroList.ruc,
        };

        this.consumer.post<any>(WebServices.URL_GET_LOG_HISTORY, params)
            .subscribe(result => {
                const document: any = result['documents'];
                fetch('data:application/zip;base64,' + document)
                    .then((resp) => {
                        return resp.blob();
                    })
                    .then((blob) => {
                        saveAs(blob, this.emisor.ruc + '-' + this.filtroList.document + '-' +
                            this.filtroList.serie + '-' +
                            this.filtroList.correlative + '.zip');
                    });
                this.cargandoList = false;
            }, err => {
                this.cargandoList = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, 'No se pudo consultar el documento', this.router);
            });

    }


}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/transaccion/logEmisorHistory/list-logEmisorHistory.component.ts